import * as i0 from '@angular/core';
import * as i1 from './overlay.module';
import * as i2 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/scrolling';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/portal';
import * as i6 from './mapping';
import * as i7 from '@angular/common';
import * as i8 from '@angular/forms';
import * as i9 from '@angular/router';
import * as i10 from './overlay-container';
import * as i11 from '../../shared/shared.module';
import * as i12 from '../adapter/adapter.module';
export const ElOverlayModuleNgFactory:i0.NgModuleFactory<i1.ElOverlayModule> = (null as any);
var _decl0_0:i2.Dir = (<any>(null as any));
var _decl0_1:i3.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_2:i3.CdkScrollable = (<any>(null as any));
var _decl0_3:i3.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_4:i3.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_5:i4.CdkConnectedOverlay = (<any>(null as any));
var _decl0_6:i4.CdkOverlayOrigin = (<any>(null as any));
var _decl0_7:i5.CdkPortal = (<any>(null as any));
var _decl0_8:i5.CdkPortalOutlet = (<any>(null as any));
var _decl0_9:i6.ElPortalDirective = (<any>(null as any));
var _decl0_10:i6.ElPortalOutletDirective = (<any>(null as any));
var _decl0_11:i7.NgClass = (<any>(null as any));
var _decl0_12:i7.NgComponentOutlet = (<any>(null as any));
var _decl0_13:i7.NgForOf<any> = (<any>(null as any));
var _decl0_14:i7.NgIf = (<any>(null as any));
var _decl0_15:i7.NgTemplateOutlet = (<any>(null as any));
var _decl0_16:i7.NgStyle = (<any>(null as any));
var _decl0_17:i7.NgSwitch = (<any>(null as any));
var _decl0_18:i7.NgSwitchCase = (<any>(null as any));
var _decl0_19:i7.NgSwitchDefault = (<any>(null as any));
var _decl0_20:i7.NgPlural = (<any>(null as any));
var _decl0_21:i7.NgPluralCase = (<any>(null as any));
var _decl0_22:i8.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_23:i8.NgSelectOption = (<any>(null as any));
var _decl0_24:i8.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_25:i8.DefaultValueAccessor = (<any>(null as any));
var _decl0_26:i8.NumberValueAccessor = (<any>(null as any));
var _decl0_27:i8.RangeValueAccessor = (<any>(null as any));
var _decl0_28:i8.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_29:i8.SelectControlValueAccessor = (<any>(null as any));
var _decl0_30:i8.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_31:i8.RadioControlValueAccessor = (<any>(null as any));
var _decl0_32:i8.NgControlStatus = (<any>(null as any));
var _decl0_33:i8.NgControlStatusGroup = (<any>(null as any));
var _decl0_34:i8.RequiredValidator = (<any>(null as any));
var _decl0_35:i8.MinLengthValidator = (<any>(null as any));
var _decl0_36:i8.MaxLengthValidator = (<any>(null as any));
var _decl0_37:i8.PatternValidator = (<any>(null as any));
var _decl0_38:i8.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_39:i8.EmailValidator = (<any>(null as any));
var _decl0_40:i8.NgModel = (<any>(null as any));
var _decl0_41:i8.NgModelGroup = (<any>(null as any));
var _decl0_42:i8.NgForm = (<any>(null as any));
var _decl0_43:i8.NgFormSelectorWarning = (<any>(null as any));
var _decl0_44:i9.RouterOutlet = (<any>(null as any));
var _decl0_45:i9.RouterLink = (<any>(null as any));
var _decl0_46:i9.RouterLinkWithHref = (<any>(null as any));
var _decl0_47:i9.RouterLinkActive = (<any>(null as any));
var _decl0_48:i9.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_49:i10.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_50:i7.AsyncPipe = (<any>(null as any));
var _decl0_51:i7.UpperCasePipe = (<any>(null as any));
var _decl0_52:i7.LowerCasePipe = (<any>(null as any));
var _decl0_53:i7.JsonPipe = (<any>(null as any));
var _decl0_54:i7.SlicePipe = (<any>(null as any));
var _decl0_55:i7.DecimalPipe = (<any>(null as any));
var _decl0_56:i7.PercentPipe = (<any>(null as any));
var _decl0_57:i7.TitleCasePipe = (<any>(null as any));
var _decl0_58:i7.CurrencyPipe = (<any>(null as any));
var _decl0_59:i7.DatePipe = (<any>(null as any));
var _decl0_60:i7.I18nPluralPipe = (<any>(null as any));
var _decl0_61:i7.I18nSelectPipe = (<any>(null as any));
var _decl0_62:i7.KeyValuePipe = (<any>(null as any));
var _decl0_65:i6.ElCdkMappingModule = (<any>(null as any));
var _decl0_64:i11.ElSharedModule = (<any>(null as any));
var _decl0_66:i12.ElCdkAdapterModule = (<any>(null as any));
var _decl0_67:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_68:i0.ElementRef<any> = (<any>(null as any));
function _View_ElOverlayContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_ElOverlayContainerComponent_1_1():void {
  if (_decl0_49.isStringContent) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_49.content;
    currVal_0;
  }
}
function _View_ElOverlayContainerComponent_1_2():void {
  var _any:any = (null as any);
}
function _View_ElOverlayContainerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_49.isStringContent;
  currVal_0;
}
